// extracted by mini-css-extract-plugin
export default {"Guide":"Refund_Guide__+BLXB","Privacy":"Refund_Privacy__66URO","Refund":"Refund_Refund__W9dmV","Tos":"Refund_Tos__aBFdP","nonScrollBox":"Refund_nonScrollBox__6h7cv"};